module.exports = __webpack_public_path__ + "static/media/introductory_image.7c68c67e.svg";